export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Für welche Klassenstufen ist Musik Startklar?',
    answer:
      'Für Klasse 1 bis 10. Zu jeder Klassenstufe gibt es einen eigenen Band mit 60 Seiten – Band 1–4 für die Grundschule, Band 5–10 für die Sekundarstufe I.',
  },
  {
    question: 'Passt das Material zu meinem Bundesland?',
    answer:
      'Ja. Die Einheiten orientieren sich an den Kompetenzbereichen, die in den Lehrplänen aller Bundesländer vorkommen: Singen, Musizieren, Hören, Bewegen, Gestalten und Reflektieren.',
  },
  {
    question: 'Muss ich ein Instrument spielen oder Noten lesen können?',
    answer:
      'Nein. Jede Stunde hat ein Lehrer-Skript zum Vorlesen und eine Bildfolge Schritt für Schritt. Alles, was vorgespielt werden müsste, hat eine Alternative mit Klatschen, Sprechen oder Summen.',
  },
  {
    question: 'Brauche ich Instrumente oder besondere Materialien?',
    answer:
      'Nein. Zu jedem Material steht eine kostenlose Alternative – zum Beispiel Becher mit Reis, Bleistifte als Klanghölzer oder der eigene Körper.',
  },
  {
    question: 'Welches Format bekomme ich?',
    answer:
      'Alle Bände und Boni sind PDF-Dateien im A4-Format – zum Ausdrucken oder digital am Whiteboard, Tablet oder Laptop.',
  },
  {
    question: 'Wie erhalte ich das Paket?',
    answer:
      'Direkt nach der Bezahlung bekommst du eine E-Mail mit deinem Download-Link. Du kannst sofort loslegen.',
  },
  {
    question: 'Sind die Lieder urheberrechtlich unbedenklich?',
    answer:
      'Ja. Im Material werden nur gemeinfreie Lieder und eigens erstellte Beispiele verwendet. Bekannte Werke werden nur mit Titel genannt.',
  },
  {
    question: 'Kann ich das Material in mehreren Klassen verwenden?',
    answer:
      'Ja, für deinen eigenen Unterricht in allen deinen Klassen, so oft du möchtest.',
  },
  {
    question: 'Ist es eine einmalige Zahlung?',
    answer:
      'Ja. Du zahlst einmal 19 € – kein Abo, keine versteckten Kosten.',
  },
]
